export default "__VITE_ASSET__D72TmXNK__"